export default defineNuxtPlugin(nuxtApp => {
	const routes = useApiRoutes().get();
	addRouteMiddleware((to, from) => {
		const path = to.path;
		if (path.startsWith('/izdelki/') && path.endsWith('-katalog/') && !routes[path] && to.meta.template == 'Error404') {
			return navigateTo({
				path: '/katalog-neobstaja/',
				query: {
					missing_url: to.params.slug[1],
				},
				replace: true,
				redirectCode: 301,
			});
		}
	});
});
